import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgNurseFemale2 = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M20.0117 21.375C19.3041 19.8793 18.1862 18.6153 16.7883 17.7302C15.3903 16.845 13.7697 16.3751 12.1151 16.3751C10.4604 16.3751 8.8398 16.845 7.44183 17.7302C6.04385 18.6153 4.926 19.8793 4.21838 21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.54504 17.1367L12.115 21.375L15.685 17.1367"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9783 17.855C17.9507 17.6912 18.8997 17.4097 19.8041 17.0167C20.1033 16.8822 20.3377 16.6355 20.4566 16.3298C20.5756 16.0241 20.5696 15.6838 20.4399 15.3825L19.2933 12.7067C19.0932 12.24 18.99 11.7377 18.9899 11.23V9.5C18.9925 7.7793 18.3472 6.12071 17.1824 4.85416"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.0475 4.85416C5.88274 6.12071 5.23745 7.7793 5.24 9.5V11.23C5.23988 11.7377 5.13669 12.24 4.93666 12.7067L3.79 15.3825C3.66035 15.6838 3.65435 16.0241 3.7733 16.3298C3.89225 16.6355 4.12662 16.8822 4.42583 17.0167C5.32974 17.4096 6.2781 17.6911 7.25 17.855"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2967 7.625H11.9333C11.6639 8.52786 11.1102 9.31966 10.3547 9.88268C9.59923 10.4457 8.68221 10.7499 7.73999 10.75C7.73999 11.9103 8.20093 13.0231 9.0214 13.8436C9.84187 14.6641 10.9547 15.125 12.115 15.125C13.2753 15.125 14.3881 14.6641 15.2086 13.8436C16.0291 13.0231 16.49 11.9103 16.49 10.75C15.5478 10.7499 14.6308 10.4457 13.8753 9.88268C13.1198 9.31966 12.5661 8.52786 12.2967 7.625V7.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.49 7.625H7.74001L6.87834 4.1775C6.83239 3.99327 6.82902 3.801 6.86847 3.61527C6.90792 3.42954 6.98917 3.25524 7.10604 3.1056C7.22291 2.95596 7.37233 2.83491 7.54297 2.75163C7.7136 2.66836 7.90097 2.62505 8.09084 2.625H16.1392C16.329 2.62505 16.5164 2.66836 16.687 2.75163C16.8577 2.83491 17.0071 2.95596 17.124 3.1056C17.2408 3.25524 17.3221 3.42954 17.3615 3.61527C17.401 3.801 17.3976 3.99327 17.3517 4.1775L16.49 7.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgNurseFemale2.displayName = 'SvgNurseFemale2';
export default SvgNurseFemale2;
